<template>
  <div class="mt-3" >
    <div class="flex mb-2">
      <div class="flex" style="align-items: center;">
        <vx-input-group class="input-group-with-dropdown-for-filtering" style="">
          <template slot="prepend">
            <div class="prepend-text ">
              <span><feather-icon class="pt-1" icon="FilterIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
            </div>
          </template>

          <v-select
            ref="filterDropdown"
            class="w-full style-chooser filter-dropdown"
            placeholder="Please select..."
            :options="filterList"
            v-model="filterDropdown"
          />
        </vx-input-group>
      </div>
      <vx-input-group v-if="filterDropdown" class="input-group-with-picker-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <month-picker-input  class="dark-picker" :default-month="(new Date().getMonth()) + 1" v-model="yearMonthPicker" variant="dark"/>

        <template slot="append">
          <div class="append-text">
            <span><feather-icon class="pt-2" icon="ChevronDownIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>
      </vx-input-group>
    </div>

    <div class="flex mb-2" v-if="false">
      <div class="flex" style="align-items: center;">
        <custom-skeleton animation="wave" class="mr-4" type="text" :count="1" height="33.5px" width="215px"></custom-skeleton>
      </div>
      <custom-skeleton animation="wave"  type="text" :count="1" height="33.5px" width="251px"></custom-skeleton>
    </div>
    
    <vx-card v-if="!isLoading">
      <vue-apex-charts type="line" height="350" :options="chartOptions" :series="series" :title="title"/>
    </vx-card>
    
    <vx-card v-if="isLoading">
      <div class="vx-row w-full mb-1" style="justify-content: center;">
        <custom-skeleton animation="wave" class="mr-2"  type="text" :count="1" height="18px" width="100px"></custom-skeleton>
      </div>
      <div class="vx-row w-full mb-1">
        <custom-skeleton animation="wave" class="mr-2"  type="text" :count="1" height="18px" width="77px"></custom-skeleton>
        <custom-skeleton animation="wave"  type="text" :count="1" height="18px" width="77px"></custom-skeleton>
      </div>
      <custom-skeleton animation="wave"  type="text" :count="1" height="295px" width="100%"></custom-skeleton>
    </vx-card>
    
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import { MonthPickerInput } from 'vue-month-picker'
import CustomSkeleton from './CustomSkeleton.vue'
export default {
  components:{
    VueApexCharts,
    vSelect,
    MonthPickerInput,
    CustomSkeleton
  },
  props:{
    series: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filterList: {
      type: Array,
      requried: true
    },
    isLoading:{
      type:Boolean,
      required:true,
    }
  },
  data(){
    return{
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: true
          }
        },
        colors: ['#147AD6', '#C0C0C0'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: this.title,
          align: 'center',
        },
        grid: {
          borderColor: '#4e515e',
          row: {
            colors: ['transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: Array.apply(null, {length: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate() + 1}).map(Number.call, Number).slice(1),
          title: {
            text: 'Days in Month'
          }
        },
        yaxis: {
          title: {
            text: 'Minutes'
          },
          min: 0,
          // max: 100
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          floating: true,
          offsetY: -25,
          offsetX: -5
        },
      },
      filterDropdown: null,
      yearMonthPicker:null,
    }
  },
  watch:{
    filterDropdown:function(){
      if(this.filterDropdown.value && this.yearMonthPicker){
        this.filterDropdownChanged();
        this.chartOptions.xaxis.categories =  Array.apply(null, {length: new Date(new Date(this.yearMonthPicker.year), new Date(this.yearMonthPicker.monthIndex), 0).getDate() + 1}).map(Number.call, Number).slice(1);
      }
    },
    yearMonthPicker:function(){
      if(this.filterDropdown.value && this.yearMonthPicker){
        this.filterDropdownChanged();
        this.chartOptions.xaxis.categories =  Array.apply(null, {length: new Date(new Date(this.yearMonthPicker.year), new Date(this.yearMonthPicker.monthIndex), 0).getDate() + 1}).map(Number.call, Number).slice(1);
      }
    },
    isLoading:function(){
      if(!this.isLoading){
        setTimeout(() => {
          var zoomOutBtn = document.getElementsByClassName('apexcharts-zoomout-icon');
          zoomOutBtn.forEach(element => {
            element.click();
          });
        }, 50);
      }
    }
  },
  methods:{
    yearMonthUpdated(newDateObj) {
      
    },
    filterDropdownChanged() {
      if (this.filterDropdown.value) {
        this.$emit("filterDropdownChanged", this.filterDropdown.label,this.filterDropdown.value,this.yearMonthPicker);
      }
    }
  },
  mounted(){
  },
  
}
</script>